import { message } from 'antd'
import { useFlags } from 'launchdarkly-react-client-sdk'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { MeContext } from '../../api'
import { hasSupplierPortalAccess } from '../../api/utils/supplierPortalAccess'
import { LaunchDarklyFeatures } from '../../common/constants'

export const SupplierPortalGuardedRoute: React.FC<{ children?: React.ReactNode }> = props => {
  const { children: Component } = props
  const navigate = useNavigate()
  const { data: meData } = React.useContext(MeContext)
  const featureFlags = useFlags()

  const supplierPortalEnabled = featureFlags[LaunchDarklyFeatures.supplierPortal]

  // #7806 — the shared portal-access predicate; denial mechanics below are unchanged.
  const isNotAccessible = !!meData?.me && !hasSupplierPortalAccess(meData.me, supplierPortalEnabled)

  React.useEffect(() => {
    if (isNotAccessible) {
      message.warn({
        key: 'supplier-portal-guard-route-warn',
        content: 'You do not have permission to visit this page',
      })
      navigate('/')
    }
  }, [isNotAccessible, navigate])

  return !!meData?.me && !isNotAccessible ? <>{Component}</> : <></>
}
